module.exports = __webpack_public_path__ + "img/logo.01c542ce.png";